import $ from "jquery";
import { fetchEnquiry, ajax, postEnquiry } from "./api";
import { getApiKey, getProductIds } from "./../selectors";
import geocode from "./../utils/geocode";
import utils from "utils";
geocode.setApiKey("AIzaSyACkQ6Pjc-vmQjLjH4HgvA9G616-cFpA6o");

const getProductJson = product => {
    let isWindow = product.ItemType.Name === "Window";
    let isDoor = product.ItemType.Name === "Door";
    let isConservatory = product.ItemType.Name === "Conservatory";
    let isAdditional = product.ItemType.Name === "Additional";
    let isUPVC = (product.Type && product.Type.IsComposite === false) || false;
    let isComposite = (product.Type && product.Type.IsComposite === true) || false;

    var typeJson = {};
    var extras = [];

    if (isWindow) {
        extras = [];
        if (product.HasLock) extras.push({ ExtraId: product.Lock.Id, Quantity: 1 });
        if (product.HasHandle) extras.push({ ExtraId: product.Handle.Id, Quantity: 1 });
        typeJson = {
            productId: product.Style.Id,
            styleId: product.Design.Id,
            heightMillimetres: product.Size.Height,
            widthMillimetres: product.Size.Width,
            roomId: product.Room.Id,
            colourId: product.Colour.Id
        };
    }
    if (isDoor && isUPVC) {
        extras = [{ ExtraId: product.Handle.Id, Quantity: 1 }];
        if (product.HasLock) extras.push({ ExtraId: product.Lock.Id, Quantity: 1 });
        if (product.HasLetterbox) extras.push({ ExtraId: product.Letterbox.Id, Quantity: 1 });
        typeJson = {
            productId: product.Type.Id,
            heightMillimetres: product.Size.Height,
            widthMillimetres: product.Size.Width,
            styleId: product.Model.Id,
            roomId: product.Room.Id,
            colourId: product.Colour.Id
        };
    }
    if (isDoor && isComposite) {
        extras = [
            { ExtraId: product.Colour.Interior.Id, Quantity: 1 },
            { ExtraId: product.Colour.Exterior.Id, Quantity: 1 },
            { ExtraId: product.Handle.Id, Quantity: 1 }
        ];

        if (product.HasKnocker) extras.push({ ExtraId: product.Knocker.Id, Quantity: 1 });
        if (product.HasLetterbox) extras.push({ ExtraId: product.Letterbox.Id, Quantity: 1 });

        typeJson = {
            productId: product.Type.Id,
            heightMillimetres: product.Size.Height,
            widthMillimetres: product.Size.Width,
            styleId: product.Style.Id,
            roomId: product.Room.Id,
            colourId: product.Frame.Id,
            ImageBase64: product.FlattenedImageSrc.replace("data:image/png;base64,", "")
        };
    }


    if (isConservatory) {
        extras = [
            { ExtraId: product.Design.Id, Quantity: 1 }
        ];
        typeJson = {
            productId: product.Type.Id,
            styleId: product.Style.Id,
            heightMillimetres: Math.round(utils.convertWindowSize(product.Size.UserSelected.Height, product.Size.UserSelected.Unit, "mm")),
            widthMillimetres: Math.round(utils.convertWindowSize(product.Size.UserSelected.Width, product.Size.UserSelected.Unit, "mm")),
            roomId: 25,
            colourId: product.Colour.Id,
            ImageBase64: product.FlattenedImageSrc.replace("data:image/png;base64,", "")
        };
    }

    if(isAdditional){
        typeJson = {
            productId: product.Type.Id,
            colourId: 1,
            roomId: 24
        };
    }

    var productJson = {
        metadata: JSON.stringify(product),
        productSuiteId: product.ItemType.Id,
        EnquiryProductExtras: extras,
        enquiryProductGlass:{},
        Quantity: product.Quantity,
        ...typeJson
    };
    if(isWindow || isDoor){
        productJson.enquiryProductGlass =  {
            glassTypeId: product.Efficiency.GlassTypeId,
            wer: product.Efficiency.Name
        };
    }

    return productJson;
};

const getJsonToPost = (productList, enquiryUid, customerDetails) => {
    let jsonData = {
        RetailCustomer: {
            ContactName: customerDetails.name || ".",
            ContactFirstName: customerDetails.name || ".",
            ContactLastName: ".",
            ContactEmail: customerDetails.email || "",
            OtherPhone: customerDetails.telephone || "",
            Address1: "",
            Postcode: customerDetails.postcode || "",
            consentCommunications: customerDetails.consentCommunication || false,
            consentEmailmarketing: customerDetails.consentMarketingEmails || false,
            consentPhonemarketing: customerDetails.consentMarketingPhone || false
        },
        enquiryUid: enquiryUid,
        enquiryProducts: $.map(productList, value => getProductJson(value))
    };

    return jsonData;
};

export const lookupInstallers = (addressString, lat, lng, callback) => {
    return (dispatch, getState) => {

        const ProductIds = getProductIds(getState());

        dispatch({
            type: "LOAD_INSTALLERS",
            payload: ajax("POST", "enquiry/GetNearestQuoteBuilderUsersForProducts", {
                Customer: {locationInfo:{ address: addressString, latitude: lat, longitude: lng }},
                ProductIds: ProductIds
            })
        }).then(() => {
            callback(getState().Installers.length);
        });
    };
};

export const getGoogleReviews = placeIds => {
    let service = new window.google.maps.places.PlacesService($("<div></div>").get(0));

    return dispatch => {
        for (let i = 0; i < placeIds.length; i++) {
            if (!placeIds[i]) continue;

            service.getDetails({ placeId: placeIds[i] }, (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    dispatch({
                        type: "ADD_GOOGLE_REVIEW",
                        payload: place.reviews,
                        meta: { id: placeIds[i] }
                    });
                }
            });
        }
    };
};

export const saveContactDetails = (contactDetails, callback) => {
    return dispatch => {
        dispatch({
            type: "SAVE_CONTACT_DETAILS",
            payload: contactDetails
        });

        callback();
    };
};

export const lookupAddress = addressString => {
    return dispatch => {
        if (!addressString) {
            dispatch({ type: "GOOGLE_GEOCODE_ADDRESS", payload: [] });
            return;
        }
        if (addressString.slice(-4) !== ", UK") addressString += ", UK";

        geocode.fromAddress(addressString).then(data => {
            dispatch({
                type: "GOOGLE_GEOCODE_ADDRESS",
                payload: data.results
            });
        });
    };
};

export const saveInstallerChoice = (installerIds, callback) => {
    return dispatch => {
        dispatch({
            type: "SELECTED_INSTALLERS",
            payload: installerIds
        });

        callback();
    };
};

export const sendQuoteRequest = (priced, emailFormValues, callback) => {
    return (dispatch, getState) => {
        $.when()
            // if we have an email, start by dispatching an event to save it
            .then(() => {
                if (emailFormValues) {
                    dispatch({
                        type: "SAVE_CONTACT_DETAILS",
                        payload: { ...emailFormValues }
                    });
                }
            })
            // start by getting the enquiryUid
            // either from the State if we've loaded one with the page
            // or make a new enquiry
            .then(() => {
                let EnquiryUid = getState().EnquiryUid;

                if (EnquiryUid) return EnquiryUid;

                return fetchEnquiry(getApiKey(getState()), "CreateEnquiry");
            })
            // get the Uid from the ajax query
            .then(enquiryData => {
                let enquiryUid = enquiryData;

                if (enquiryData.result) enquiryUid = enquiryData.result.enquiryUid;

                return enquiryUid;
            })
            // dispatch an action to save the uid
            // post the save enquiry JSON
            .then(enquiryUid => {
                dispatch({ type: "ENQUIRY_CREATED", payload: enquiryUid });
                return postEnquiry(
                    getApiKey(getState()),
                    "PUT",
                    "SaveEnquiry",
                    getJsonToPost(getState().ProductList, enquiryUid, getState().CustomerDetails)
                );
            })
            // call the callback
            .then(data => {
                let state = getState();
                let enquiryUid = data.result.enquiryUid;

                if (priced) {
                    let selectedInstallers = state.SelectedInstallers;

                    if (selectedInstallers.length === 0) {
                        selectedInstallers.push(getApiKey(state));
                    }

                    return postEnquiry(getApiKey(state), "GET", "BatchPriceEnquiry", {
                        enquiryUid,
                        tradeCustList: selectedInstallers,
                        ignoreMissingProducts: true
                    });
                } else {
                    return postEnquiry(getApiKey(state), "GET", "SendUnpricedReport", {
                        enquiryUid
                    });
                }
            })
            .then(batchResponse => {
                // Log the full BatchPriceEnquiry response for debugging
                console.log("BatchPriceEnquiry response:", batchResponse);

                // Extract per-installer { tradeCustomerGuid, enquiryUid } pairs from the response.
                // Shape: batchResponse.result.enquiries = [{ enquiryUid, tradeCustomerGuid, … }, …]
                let pricedEnquiries = [];
                try {
                    const enquiries =
                        batchResponse &&
                        batchResponse.result &&
                        Array.isArray(batchResponse.result.enquiries)
                            ? batchResponse.result.enquiries
                            : [];

                    pricedEnquiries = enquiries
                        .filter(e => e.tradeCustomerGuid && e.enquiryUid)
                        .map(e => ({
                            tradeCustomerGuid: e.tradeCustomerGuid,
                            enquiryUid: e.enquiryUid,
                        }));

                    console.log("pricedEnquiries extracted:", pricedEnquiries);
                } catch (e) {
                    console.error("sendQuoteRequest: failed to extract pricedEnquiries", e);
                }

                callback(pricedEnquiries);
            });
    };
};

export const sendAdditionalQuoteRequest = ({emailFormValues, item}, callback) => {
    return (dispatch, getState) => {
        $.when()
            // if we have an email, start by dispatching an event to save it
            .then(() => {
                if (emailFormValues) {
                    dispatch({
                        type: "SAVE_CONTACT_DETAILS",
                        payload: { ...emailFormValues }
                    });
                }
            })
            // start by getting the enquiryUid
            // either from the State if we've loaded one with the page
            // or make a new enquiry
            .then(() => {
                let EnquiryUid = getState().EnquiryUid;

                if (EnquiryUid) return EnquiryUid;

                return fetchEnquiry(getApiKey(getState()), "CreateEnquiry");
            })
            // get the Uid from the ajax query
            .then(enquiryData => {
                let enquiryUid = enquiryData;

                if (enquiryData.result) enquiryUid = enquiryData.result.enquiryUid;

                return enquiryUid;
            })
            // dispatch an action to save the uid
            // post the save enquiry JSON
            .then(enquiryUid => {
                dispatch({ type: "ENQUIRY_CREATED", payload: enquiryUid });

                return postEnquiry(
                    getApiKey(getState()),
                    "PUT",
                    "SaveEnquiry",
                    getJsonToPostAdditionalQuote(item, enquiryUid, getState().CustomerDetails)
                );
            })
            // call the callback
            .then(data => {
                let state = getState();
                let enquiryUid = data.result.enquiryUid;
                return postEnquiry(getApiKey(state), "GET", "SendUnpricedReport", {
                    enquiryUid
                });
            })
            .then(() => {
                callback();
            });
    };
};

const getJsonToPostAdditionalQuote = (product, enquiryUid, customerDetails) => {
    console.debug("product", product);
    let jsonData = {
        RetailCustomer: {
            ContactName: customerDetails.name || ".",
            ContactEmail: customerDetails.email || "",
            OtherPhone: customerDetails.telephone || "",
            Postcode: customerDetails.postcode || "",
            consentCommunications: customerDetails.consentCommunication || false
        },
        enquiryUid: enquiryUid,
        enquiryProducts: [{
            productSuiteId: product.productSuite.id,
            Quantity: 1,
            productId: product.id,
            ColourId: 1,
            EnquiryProductGlass:{
                GlassTypeId: 8,
                wer: "C"
            },
            RoomId: 24
        }]
    };


    return jsonData;
};


export const loadQuote = (enquiryUid, callback) => {
    return (dispatch, getState) => {
        $.when()
            .then(() => {
                return fetchEnquiry(getApiKey(getState()), "/GetEnquiry/" + enquiryUid);
            })
            .then(data => {
                let productList = data.result.enquiryProducts.map(p => JSON.parse(p.metaData));

                dispatch({
                    type: "LOAD_QUOTE",
                    payload: productList
                });

                callback();
            });
    };
};

export const saveForLater = (emailForValues, emailQuote, callback) => {
    if (emailQuote) {
        return sendQuoteRequest(false, emailForValues, callback);
    } else {
        return (dispatch, getState) => {
            $.when()
                // if we have an email, start by dispatching an event to save it
                .then(() => {
                    if (emailForValues.email) {
                        dispatch({
                            type: "SAVE_CONTACT_DETAILS",
                            payload: { ...emailForValues }
                        });
                    }
                })
                // start by getting the enquiryUid
                // either from the State if we've loaded one with the page
                // or make a new enquiry
                .then(() => {
                    let EnquiryUid = getState().EnquiryUid;

                    if (EnquiryUid) return EnquiryUid;

                    return fetchEnquiry(getApiKey(getState()), "CreateEnquiry");
                })
                // get the Uid from the ajax query
                .then(enquiryData => {
                    let enquiryUid = enquiryData;

                    if (enquiryData.result) enquiryUid = enquiryData.result.enquiryUid;

                    return enquiryUid;
                })
                // dispatch an action to save the uid
                // post the save enquiry JSON
                .then(enquiryUid => {
                    dispatch({ type: "ENQUIRY_CREATED", payload: enquiryUid });

                    return postEnquiry(
                        getApiKey(getState()),
                        "POST",
                        "SaveAndSendLink",
                        getJsonToPost(
                            getState().ProductList,
                            enquiryUid,
                            getState().CustomerDetails
                        )
                    );
                })
                .then(() => {
                    callback();
                });
        };
    }
};

// GetEnquiryProductSvg?styleId=34&productId=1&width=1500&height=1500&colourId=3&roomId=2&extraIdList[0]=8&extraIdList[1]=9
export const getSummaryImageSvg = (body, randomIdForImageReplacement) => {
    return (dispatch, getState) => {
        postEnquiry(getApiKey(getState()), "GET", "GetEnquiryProductSvg", body).then(data => {
            setTimeout(
                () =>
                    dispatch({
                        type: "LOAD_SVG_IMAGE",
                        payload: {
                            randomIdForImageReplacement,
                            data
                        }
                    }),
                1000
            );
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/enquiry.js